<template>
    <div class="automation-action-settings">

        <div class="form-group">
            <label>{{ t('automations-form-actions-remove_smart_insertion-space_label') }}</label>
            <select class="form-control" v-model="settings.spaces_id">
                <option :value="null">{{ t('automations-form-actions-remove_smart_insertion-space_options_any') }}</option>
                <option v-for="space in spaces" :value="space.id" :key="space.id">
                    {{ space.name }}
                </option>
            </select>
        </div>

        <div class="form-group">
            <label>{{ t('automations-form-actions-remove_smart_insertion-insertion_name_label') }}</label>
            <div>
                <small>
                    {{ t('automations-form-actions-remove_smart_insertion-insertion_name_help') }}
                </small>
            </div>
            <input v-model="settings.key" type="text" class="form-control">
        </div>
    </div>
</template>
<style scoped lang="scss">
iframe {
    border: none;
    width: 100%;
    min-height: 500px;
}

.iframe-holder {
    position: relative;
    border: 1px solid #333;
}

.wpp-cloud-components {
    display: flex;
    flex-direction: column;
    gap: 20px;

    input {
        display: inline-block;
        width: 400px;
        max-width: 80%;
    }

    .text-example {
        padding: 15px;
        border-radius: 10px;
        background: #f5f5f5;
        display: inline-block;
        width: 416px;
        max-width: 80%;
        font-size: 14px;

        strong {
            font-weight: 500;
            font-size: 16px;
        }
    }
}
</style>
<script>
import keviApi from "../../../keviApi";

export default {
    props: {
        value: {},
        properties: {},
        actionId: String,
    },
    data: function () {
        const settings = this.properties.settings ? this.properties.settings : {
            key: null,
            strategy: 'exact_match',
            spaces_id: null,
        };
        return {
            title: this.t("automations-form-actions-remove_smart_insertion-title"),
            description: this.t("automations-form-actions-remove_smart_insertion-description"),
            spaces: [],
            settings,
            editingHTML: null,
        }
    },
    computed: {
        space() {
            return this.spaces.find(space => space.id === this.settings.spaces_id);
        },
    },
    async mounted() {
        await this.loadSpaces();
        this.$emit("mounted", this);
    },
    methods: {
        t(term, replaces) {
            return this.$root.t(term, replaces);
        },
        async loadSpaces() {
            const options = keviApi.getOptions("smart-insertions/spaces", "GET");
            this.$http(options).then((response) => {
                this.spaces = response.data;
            });
        },
        changed: function () {
            this.$emit("propertiesUpdated", {
                settings: this.settings,
            });
        },
        isValid: function () {
            return true;
        },
    },
    watch: {
        properties: {
            handler: function (newVal) {
                this.settings = newVal.settings || {
                    key: null,
                    strategy: 'exact_match',
                    spaces_id: null,
                };
            },
            deep: true,
        },
        settings: {
            handler: function (newVal) {
                this.changed();
            },
            deep: true,
        },
    },
};
</script>
